/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Formule du produit rattachée au tunnel.
 * @export
 * @interface FunnelFormuleLightDto
 */
export interface FunnelFormuleLightDto {
    /**
     * 
     * @type {string}
     * @memberof FunnelFormuleLightDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelFormuleLightDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelFormuleLightDto
     */
    designation?: string | null;
}

/**
 * Check if a given object implements the FunnelFormuleLightDto interface.
 */
export function instanceOfFunnelFormuleLightDto(value: object): value is FunnelFormuleLightDto {
    return true;
}

export function FunnelFormuleLightDtoFromJSON(json: any): FunnelFormuleLightDto {
    return FunnelFormuleLightDtoFromJSONTyped(json, false);
}

export function FunnelFormuleLightDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelFormuleLightDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'designation': json['designation'] == null ? undefined : json['designation'],
    };
}

export function FunnelFormuleLightDtoToJSON(json: any): FunnelFormuleLightDto {
    return FunnelFormuleLightDtoToJSONTyped(json, false);
}

export function FunnelFormuleLightDtoToJSONTyped(value?: FunnelFormuleLightDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'designation': value['designation'],
    };
}

